export class Unit {
    id: number;
    order: number; // Pulled in correct order from WP REST API

    constructor(unit: any) { // Expects a WP REST API response
        this.id = parseInt(unit.id);
        this.order = unit.order;
    }
}